export default class PageManager {
    before(next) {
        next();
    }

    loaded(next) {
        next();
    }

    after(next) {
        next();
    }

    type() {
        return this.constructor.name;
    }
}



// WEBPACK FOOTER //
// ./assets/js/page-manager.js